// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button__button-ae5736 {
  width: 36px;
  height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Button__button-ae5736 + .Button__button-ae5736 {
  margin-inline-start: 6px;
}
.Button__button-ae5736.Button__theme-base-c2e471 > .Button__icon-d2c6c8 {
  fill: var(--base-120);
}
.Button__button-ae5736.Button__theme-base-c2e471:hover {
  background-color: var(--base-15);
}
.Button__button-ae5736.Button__theme-base-c2e471:focus-visible {
  background-color: var(--base-15);
}
.Button__button-ae5736.Button__theme-base-c2e471:active {
  background-color: var(--base-17);
}
.Button__button-ae5736.Button__theme-base-c2e471.Button__active-a5009a {
  background-color: var(--brand-primary-0);
}
.Button__button-ae5736.Button__theme-base-c2e471:disabled {
  background-color: transparent;
  cursor: default;
}
.Button__button-ae5736.Button__theme-primary-d16d23 > .Button__icon-d2c6c8 {
  fill: var(--danger-40);
}
.Button__button-ae5736.Button__theme-primary-d16d23:hover {
  background-color: var(--brand-primary-0);
}
.Button__button-ae5736.Button__theme-primary-d16d23:focus-visible {
  background-color: var(--brand-primary-0);
}
.Button__button-ae5736.Button__theme-primary-d16d23:active {
  background-color: var(--brand-primary-10);
}
.Button__button-ae5736.Button__theme-primary-d16d23:disabled {
  background-color: transparent;
  cursor: default;
}
.Button__button-ae5736.Button__theme-primary-d16d23:disabled > .Button__icon-d2c6c8 {
  fill: var(--danger-10);
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingMenu/Content/components/Button/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,wBAAA;AACJ;AAGI;EACE,qBAAA;AADN;AAII;EACE,gCAAA;AAFN;AAKI;EACE,gCAAA;AAHN;AAMI;EACE,gCAAA;AAJN;AAOI;EACE,wCAAA;AALN;AAQI;EACE,6BAAA;EACA,eAAA;AANN;AAWI;EACE,sBAAA;AATN;AAYI;EACE,wCAAA;AAVN;AAaI;EACE,wCAAA;AAXN;AAcI;EACE,yCAAA;AAZN;AAeI;EACE,6BAAA;EACA,eAAA;AAbN;AAeM;EACE,sBAAA;AAbR","sourcesContent":[".button {\n  width: 36px;\n  height: 36px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & + & {\n    margin-inline-start: 6px;\n  }\n\n  &.theme-base {\n    & > .icon {\n      fill: var(--base-120);\n    }\n\n    &:hover {\n      background-color: var(--base-15);\n    }\n\n    &:focus-visible {\n      background-color: var(--base-15);\n    }\n\n    &:active {\n      background-color: var(--base-17);\n    }\n\n    &.active {\n      background-color: var(--brand-primary-0);\n    }\n\n    &:disabled {\n      background-color: transparent;\n      cursor: default;\n    }\n  }\n\n  &.theme-primary {\n    & > .icon {\n      fill: var(--danger-40);\n    }\n\n    &:hover {\n      background-color: var(--brand-primary-0);\n    }\n\n    &:focus-visible {\n      background-color: var(--brand-primary-0);\n    }\n\n    &:active {\n      background-color: var(--brand-primary-10);\n    }\n\n    &:disabled {\n      background-color: transparent;\n      cursor: default;\n\n      & > .icon {\n        fill: var(--danger-10);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button__button-ae5736`,
	"theme-base": `Button__theme-base-c2e471`,
	"themeBase": `Button__theme-base-c2e471`,
	"icon": `Button__icon-d2c6c8`,
	"active": `Button__active-a5009a`,
	"theme-primary": `Button__theme-primary-d16d23`,
	"themePrimary": `Button__theme-primary-d16d23`
};
module.exports = ___CSS_LOADER_EXPORT___;
